import { createSlice } from "redux-starter-kit";

export const pagingationSlice = createSlice({
  slice: "pagination",
  initialState: { activePage: 1, numPages: 563 },
  reducers: {
    setPage: (state, action) => {
      state.activePage = action.payload.activePage;
      state.numPages = action.payload.numPages ? action.payload.numPages : state.numPages;
    },
  },
});
